import { _ as t } from "../internals/export.js";
import { g as r } from "../internals/global.js";
import { f as e } from "../internals/function-call.js";
import { f as o } from "../internals/function-uncurry-this.js";
import { d as s } from "../internals/descriptors.js";
import { s as n } from "../internals/symbol-constructor-detection.js";
import { f as i } from "../internals/fails.js";
import { h as a } from "../internals/has-own-property.js";
import { o as p } from "../internals/object-is-prototype-of.js";
import { a as m } from "../internals/an-object.js";
import { t as f } from "../internals/to-indexed-object.js";
import { t as l } from "../internals/to-property-key.js";
import { t as c } from "../internals/to-string.js";
import { c as u } from "../internals/create-property-descriptor.js";
import { o as j } from "../internals/object-create.js";
import { o as b } from "../internals/object-keys.js";
import "../internals/object-get-own-property-names.js";
import "../internals/object-get-own-property-names-external.js";
import "../internals/object-get-own-property-symbols.js";
import "../internals/object-get-own-property-descriptor.js";
import "../internals/object-define-property.js";
import "../internals/object-define-properties.js";
import "../internals/object-property-is-enumerable.js";
import { d } from "../internals/define-built-in.js";
import { d as y } from "../internals/define-built-in-accessor.js";
import { s as h } from "../internals/shared.js";
import { s as g } from "../internals/shared-key.js";
import { h as w } from "../internals/hidden-keys.js";
import { u as _ } from "../internals/uid.js";
import { w as v } from "../internals/well-known-symbol.js";
import "../internals/well-known-symbol-wrapped.js";
import { w as x } from "../internals/well-known-symbol-define.js";
import { s as k } from "../internals/symbol-define-to-primitive.js";
import { s as S } from "../internals/set-to-string-tag.js";
import { i as O } from "../internals/internal-state.js";
import { a as P } from "../internals/array-iteration.js";
import { __exports as E } from "../../../_virtual/object-get-own-property-names.js";
import { __exports as C } from "../../../_virtual/object-get-own-property-descriptor.js";
import { __exports as D } from "../../../_virtual/object-define-property.js";
import { __exports as F } from "../../../_virtual/object-get-own-property-names-external.js";
import { __exports as I } from "../../../_virtual/object-get-own-property-symbols.js";
import { __exports as N } from "../../../_virtual/object-define-properties.js";
import { __exports as Q } from "../../../_virtual/object-property-is-enumerable.js";
import { __exports as T } from "../../../_virtual/well-known-symbol-wrapped.js";
var q = P.forEach,
  z = g("hidden"),
  A = "Symbol",
  B = "prototype",
  G = O.set,
  H = O.getterFor(A),
  J = Object[B],
  K = r.Symbol,
  L = K && K[B],
  M = r.TypeError,
  R = r.QObject,
  U = C.f,
  V = D.f,
  W = F.f,
  X = Q.f,
  Y = o([].push),
  Z = h("symbols"),
  $ = h("op-symbols"),
  tt = h("wks"),
  tr = !R || !R[B] || !R[B].findChild,
  te = s && i(function () {
    return 7 != j(V({}, "a", {
      get: function get() {
        return V(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (t, r, e) {
    var o = U(J, r);
    o && delete J[r], V(t, r, e), o && t !== J && V(J, r, o);
  } : V,
  to = function to(t, r) {
    var e = Z[t] = j(L);
    return G(e, {
      type: A,
      tag: t,
      description: r
    }), s || (e.description = r), e;
  },
  ts = function ts(t, r, e) {
    t === J && ts($, r, e), m(t);
    var o = l(r);
    return (m(e), a(Z, o)) ? (e.enumerable ? (a(t, z) && t[z][o] && (t[z][o] = !1), e = j(e, {
      enumerable: u(0, !1)
    })) : (a(t, z) || V(t, z, u(1, {})), t[z][o] = !0), te(t, o, e)) : V(t, o, e);
  },
  tn = function tn(t, r) {
    m(t);
    var o = f(r);
    return q(b(o).concat(tm(o)), function (r) {
      (!s || e(ti, o, r)) && ts(t, r, o[r]);
    }), t;
  },
  ti = function ti(t) {
    var r = l(t),
      o = e(X, this, r);
    return (!(this === J && a(Z, r)) || !!a($, r)) && (!(o || !a(this, r) || !a(Z, r) || a(this, z) && this[z][r]) || o);
  },
  ta = function ta(t, r) {
    var e = f(t),
      o = l(r);
    if (!(e === J && a(Z, o)) || a($, o)) {
      var s = U(e, o);
      return s && a(Z, o) && !(a(e, z) && e[z][o]) && (s.enumerable = !0), s;
    }
  },
  tp = function tp(t) {
    var r = W(f(t)),
      e = [];
    return q(r, function (t) {
      a(Z, t) || a(w, t) || Y(e, t);
    }), e;
  },
  tm = function tm(t) {
    var r = t === J,
      e = W(r ? $ : f(t)),
      o = [];
    return q(e, function (t) {
      a(Z, t) && (!r || a(J, t)) && Y(o, Z[t]);
    }), o;
  };
!n && (d(L = (K = function K() {
  if (p(L, this)) throw M("Symbol is not a constructor");
  var t = arguments.length && void 0 !== arguments[0] ? c(arguments[0]) : void 0,
    r = _(t),
    o = function o(t) {
      this === J && e(o, $, t), a(this, z) && a(this[z], r) && (this[z][r] = !1), te(this, r, u(1, t));
    };
  return s && tr && te(J, r, {
    configurable: !0,
    set: o
  }), to(r, t);
})[B], "toString", function () {
  return H(this).tag;
}), d(K, "withoutSetter", function (t) {
  return to(_(t), t);
}), Q.f = ti, D.f = ts, N.f = tn, C.f = ta, E.f = F.f = tp, I.f = tm, T.f = function (t) {
  return to(v(t), t);
}, s && (y(L, "description", {
  configurable: !0,
  get: function get() {
    return H(this).description;
  }
}), d(J, "propertyIsEnumerable", ti, {
  unsafe: !0
}))), t({
  global: !0,
  constructor: !0,
  wrap: !0,
  forced: !n,
  sham: !n
}, {
  Symbol: K
}), q(b(tt), function (t) {
  x(t);
}), t({
  target: A,
  stat: !0,
  forced: !n
}, {
  useSetter: function useSetter() {
    tr = !0;
  },
  useSimple: function useSimple() {
    tr = !1;
  }
}), t({
  target: "Object",
  stat: !0,
  forced: !n,
  sham: !s
}, {
  create: function create(t, r) {
    return void 0 === r ? j(t) : tn(j(t), r);
  },
  defineProperty: ts,
  defineProperties: tn,
  getOwnPropertyDescriptor: ta
}), t({
  target: "Object",
  stat: !0,
  forced: !n
}, {
  getOwnPropertyNames: tp
}), k(), S(K, A), w[z] = !0;